import React, { useEffect, useRef, useState } from "react";
import ReactCrop, { Crop, convertToPixelCrop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import setCanvasPreview from "../setCanvasPreview";
import Spinner from "../global-components/src/components/spinner/spiner";
import { cropConfig } from "../utils/crop";
import { Check } from "lucide-react";

const ASPECT_RATIO = 1;
const MIN_DIMENSION = 150;
type CropType = "profile" | "banner";

interface Props { 
  id: string;
  type: CropType;
  imageSrc: string;
  loading?: boolean;
  isOpen: boolean; // Alterado para obrigatório
  onClose: () => void; // Alterado para obrigatório
  onSave: (file: File) => void;
}

export default function ImageCropModal({ 
  imageSrc, 
  isOpen, 
  type, 
  loading = false, 
  id, 
  onClose, 
  onSave 
}: Props) { 
  const imgRef = useRef<HTMLImageElement | null>(null);
  const previewCanvasRef = useRef<HTMLCanvasElement | null>(null);
  const modalRef = useRef<HTMLDivElement | null>(null);
  const { aspect, minDimension, circular } = cropConfig[type];
  const [crop, setCrop] = useState<Crop>();
  const openCropModal = useRef<HTMLButtonElement>(null);
const closeCropModal = useRef<HTMLButtonElement>(null);


  const onImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const { width, height } = e.currentTarget;

    let cropWidthPx = width;
    let cropHeightPx = cropWidthPx / aspect;

    if (cropHeightPx > height) {
      cropHeightPx = height;
      cropWidthPx = cropHeightPx * aspect;
    }

    const cropWidthPercent = (cropWidthPx / width) * 100;
    const cropHeightPercent = (cropHeightPx / height) * 100;

    setCrop({
      unit: "%",
      width: cropWidthPercent,
      height: cropHeightPercent,
      x: (100 - cropWidthPercent) / 2,
      y: (100 - cropHeightPercent) / 2,
    });
  };

  const handleSave = async () => {
    if (!crop || !imgRef.current || !previewCanvasRef.current) return;

    setCanvasPreview(
      imgRef.current,
      previewCanvasRef.current,
      convertToPixelCrop(
        crop,
        imgRef.current.width,
        imgRef.current.height
      )
    );

    const blob = await new Promise<Blob>((resolve) =>
      previewCanvasRef.current!.toBlob(
        (b) => resolve(b!),
        "image/png"
      )
    );

    const file = new File([blob], "cropped-image.png", {
      type: "image/png",
    });

    onSave(file);
  };

  useEffect(() => {
    if (isOpen) {
      openCropModal.current?.click();
    } else {
      closeCropModal.current?.click();
    }
  }, [isOpen]);

  return (
    <>
    {isOpen && <div className="modal-backdrop fade show"></div>}

      <div className={`modal fade modal-crop `}  id={`modal-crop-${id}`} ref={modalRef}>
      {/* Modal */}
      <div className="modal-dialog cover-mobile" >
        <div className="modal-content">
      <button className="d-none" ref={closeCropModal} data-bs-dismiss="modal" /> 
            <div className="modal-header" style={{ borderBottom: "0!important", paddingBottom: 0, paddingTop: 11 }}>
              <button 
                type="button" 
                className="btn-close" 
                onClick={onClose}
                aria-label="Fechar"
              />
            </div>

            <div className="modal-body">
              <div style={{ display: "flex", justifyContent: "center", maxHeight: "60vh" }}>
                <ReactCrop
                  crop={crop}
                  onChange={(_, percentCrop) => setCrop(percentCrop)}
                  keepSelection
                  circularCrop={circular}
                  aspect={aspect}
                  minWidth={minDimension}
                  className="img-fluid"
                >
                  <img
                    ref={imgRef}
                    src={imageSrc}
                    alt="Crop"
                    style={{ 
                      maxWidth: '100%',
                      maxHeight: '50vh',
                      objectFit: 'contain'
                    }}
                    onLoad={onImageLoad}
                  />
                </ReactCrop>
              </div>
            <div className="modal-footer" style={{ paddingRight: 0 }}>
              <button
                type="button"
                className={`btn-subimit-post btn btn-blue`} style={{ borderRadius: "100%", height: 50, width: 50 }}
                onClick={handleSave}
                disabled={loading}
              >
                {loading ? <Spinner /> :  <Check/>}
              </button>
            </div>
            </div>

          </div>
      </div>
      </div>

      {/* Canvas oculto */}
      <canvas ref={previewCanvasRef} style={{ display: "none" }} />
      <button className="d-none" ref={openCropModal} data-bs-toggle="modal" data-bs-target={`#modal-crop-${id}`} />

    </>
  );
}